import script from "./ActionDropdownShell.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionDropdownShell.vue?vue&type=script&setup=true&lang=ts"

import "./ActionDropdownShell.vue?vue&type=style&index=0&id=14b4b73c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-14b4b73c"]])

export default __exports__